import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Grid,
  Card,
} from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import EmptyData from "components/EmptyData";
import apiClient from "Utils/apiClient";
import TokenDialogBox from "../../DialogBox/tokenData";

const Token = () => {
  const navigate = useNavigate();
  const [allData, setAllData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedNotification, setselectedNotification] = useState({});

  const getData = async () => {
    try {
      const response = await apiClient.get("/token-rewards");
      const data = response?.data || {};
      const items = Array.isArray(data.items) ? data.items : [];

      const mergedData = items.map((item) => ({
        id: item.action,
        title: item.label || item.action || "",
        body: item.amount ?? "",
        action: item.action || "",
      }));

      setAllData(mergedData);
    } catch (error) {
      toast.error(error?.message || "Failed to load token rewards");
      setAllData([]);
    }
  };

  const openModal = () => {
    setselectedNotification({});
    setOpen(true);
  };

  const close = () => {
    setOpen(false);
    getData();
  };

  const edit = (notification) => {
    setselectedNotification(notification);
    setOpen(true);
  };

  const deleteNotification = () => {
    toast.info("Token rewards are managed by the backend API and are read-only here.", {
      autoClose: 3000,
      position: toast.POSITION.TOP_CENTER,
    });
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      navigate("/authentication/sign-in");
      return;
    }

    getData();
  }, [navigate]);

  return (
    <DashboardLayout>
      {open && <TokenDialogBox open={open} onClose={close} notification={selectedNotification} />}

      <MDBox pt={12} pb={3}>
        <Grid container spacing={6} style={{ position: "relative", minHeight: "60vh" }}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                sx={{
                  textAlign: "center",
                }}
              >
                <ToastContainer />
                <MDTypography
                  variant="h6"
                  color="white"
                  sx={{
                    fontWeight: "bold",
                    fontSize: "1.5rem",
                  }}
                >
                  TOKEN DASHBOARD
                </MDTypography>
              </MDBox>

              <button
                className="btn btn-success mt-5 ms-3 mb-3"
                style={{ width: 200 }}
                onClick={() => openModal()}
              >
                ADD
              </button>

              {allData.length > 0 ? (
                <MDBox>
                  <TableContainer component={Paper}>
                    <Table aria-label="user table">
                      <TableBody>
                        <TableRow>
                          <TableCell
                            align="center"
                            className="rounded"
                            sx={{ padding: "6px", color: "black", fontWeight: "bold" }}
                          >
                            Description
                          </TableCell>
                          <TableCell
                            align="center"
                            className="rounded"
                            sx={{ padding: "6px", color: "black", fontWeight: "bold" }}
                          >
                            Token
                          </TableCell>
                          <TableCell
                            align="center"
                            className="rounded"
                            sx={{ padding: "6px", color: "black", fontWeight: "bold" }}
                          >
                            Action
                          </TableCell>
                        </TableRow>
                        {allData.map((notification, index) => (
                          <TableRow key={notification.id || index} sx={{ height: "auto" }}>
                            <TableCell align="center" className="rounded" sx={{ padding: "6px" }}>
                              {notification.title}
                            </TableCell>

                            <TableCell align="center" className="rounded" sx={{ padding: "6px" }}>
                              {notification.body}
                            </TableCell>

                            <TableCell align="center" className="rounded" sx={{ padding: "6px" }}>
                              <button
                                className="btn btn-success ms-4 mb-2"
                                style={{ width: "120px" }}
                                onClick={() => edit(notification)}
                              >
                                Edit
                              </button>
                              <button
                                className="btn btn-danger ms-4 mb-2"
                                style={{ width: "120px" }}
                                onClick={() => deleteNotification(notification)}
                              >
                                Delete
                              </button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </MDBox>
              ) : (
                <EmptyData />
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

export default Token;
